import Vue from 'vue'
import Router from 'vue-router'

// import index from '@/components/index'

// import kanban from '@/components/kanban/kanban'
// import son1 from '@/components/kanban/son1'
// import son2 from '@/components/kanban/son2'


// import lianghaoxiangguan from './lianghao.js'
// import linshi from './linshi.js'
// import zhiboxitong from './zhiboxitong.js'




import admin from './admin.js'
import yongjin from './yongjin.js'
import gongju from './gongju.js'
import weixiaodian from './weixiaodian.js'
import baobiao from './baobiao.js'
import shengchan from './shengchan.js'
import dingdan from './dingdan.js'
import tongzhixiaoxi from './tongzhixiaoxi.js'
import ziliaoku from './ziliaoku.js'
import lirun from './lirun.js'
import peifu from './peifu.js'

Vue.use(Router)

// 获取原型对象push函数
const originalPush = Router.prototype.push
// 获取原型对象replace函数
const originalReplace = Router.prototype.replace

// 修改原型对象中的push函数
Router.prototype.push = function push(location){
return originalPush.call(this , location).catch(err=>err)
}

// 修改原型对象中的replace函数
Router.prototype.replace = function replace(location){
return originalReplace.call(this , location).catch(err=>err)
}




export default new Router({
	// mode: 'history',
	routes: [
		{
			path: '/',
			redirect: '/index'
			// component: () => import('@/components/mySupplier/mySupplier')
		},

		// ...lianghaoxiangguan,

    ...admin,
    ...yongjin,
    ...gongju,
    ...weixiaodian,
    ...baobiao,
    ...shengchan,
    ...dingdan,
    ...tongzhixiaoxi,
    ...ziliaoku,
    ...lirun,
    ...peifu,


// 		// ...linshi,
//     // ...zhiboxitong,

    //首页
    {
    	path: '/index',
    	name: 'index',
    	component: () => import('@/views/index/index')
    },
    //意见反馈
    {
    	path: '/yijianfankui',
    	name: 'yijianfankui',
    	component: () => import('@/views/yijianfankui')
    },
    //首页外呼
    {
    	path: '/index/index_waihu',
    	name: 'index_waihu',
    	component: () => import('@/views/index/index_waihu')
    },
    //首页短信
    {
    	path: '/index/index_duanxin',
    	name: 'index_duanxin',
    	component: () => import('@/views/index/index_duanxin')
    },



    //loading
    {
    	path: '/loading/index',
    	name: 'loading',
    	component: () => import('@/components/loading/index')
    },

    //运营相关
    {
    	path: '/yonghuyunying',
    	name: 'yonghuyunying',
    	component: () => import('@/views/yonghuyunying/index'),
      redirect:"/yonghuyunying/qunti",
      children:[
        {
        	path: '/yonghuyunying/qunti',
        	name: 'qunti',
        	component: () => import('@/views/yonghuyunying/qunti')
        },
        {
        	path: '/yonghuyunying/guanli',
        	name: 'guanli',
        	component: () => import('@/views/yonghuyunying/guanli')
        },
        {
        	path: '/yonghuyunying/chuangjianwaihu',
        	name: 'chuangjianwaihu',
        	component: () => import('@/views/yonghuyunying/chuangjianwaihu')
        },
        {
        	path: '/yonghuyunying/chuangjianduanxin',
        	name: 'chuangjianduanxin',
        	component: () => import('@/views/yonghuyunying/chuangjianduanxin')
        },
        {
        	path: '/yonghuyunying/chuangjianrenqun',
        	name: 'chuangjianrenqun',
        	component: () => import('@/views/yonghuyunying/chuangjianrenqun')
        }
      ]
    },




    {
    	path: '/tuiguang/tuiguang_chafukuan',
    	name: 'tuiguang_chafukuan',
    	component: () => import('@/components/tuiguang/tuiguang_chafukuan')
    },
    {
			path: '/tuiguang/tuiguang_orders',
			name: 'tuiguang_orders',
			component: () => import('@/components/tuiguang/tuiguang_orders')
		},
		{
			path: '/order_production/zidongdetail',
			name: 'zidongdetail',
			component: () => import('@/components/productionManagement/zidongdetail')
		},
    {
    	path: '/shimingrenzhenging',
    	name: 'shimingrenzhenging',
    	component: () => import('@/components/shimingrenzhenging')
    },

    {
    	path: '/shimingrenzheng',
    	name: 'shimingrenzheng',
    	component: () => import('@/components/shimingrenzheng')
    },


		//直播上传单页面
		{
			path: '/zhibo',
			name: 'zhibo',
			component: () => import('@/views/zhibo')
		},


    {
    	path: '/wodezhanghu',
    	name: 'wodezhanghui',
    	component: () => import('@/views/wodezhanghu/index'),
    //   component: {render: (e) => e("router-view")},
      redirect:"/wodezhanghu/wodezhanghu",
      children:[
        {
        	path: '/wodezhanghu/wodezhanghu',
        	name: 'wodezhanghu',
        	component: () => import('@/views/wodezhanghu/wodezhanghu')
        },
        {
        	path: '/wodezhanghu/chongzhijilu',
        	name: 'chongzhijilu',
        	component: () => import('@/views/wodezhanghu/chongzhijilu')
        },
        {
        	path: '/wodezhanghu/xiaofeimingxi',
        	name: 'xiaofeimingxi',
        	component: () => import('@/views/wodezhanghu/xiaofeimingxi')
        },
        {
        	path: '/wodezhanghu/xiaofeimingxidaochu',
        	name: 'xiaofeimingxidaochu',
        	component: () => import('@/views/wodezhanghu/xiaofeimingxidaochu')
        },
      ]
    },


	//权益
	{
		path: '/quanyi',
		name: 'quanyi',
		component: () => import('@/views/quanyi'),
	},
	{
		path: '/quanyi/quanyishangpin',
		name: 'quanyishangpin',
		component: () => import('@/views/quanyishangpin'),
	},
  //号码余额查询

  {
  	path: '/haomayuechaxun',
  	name: 'haomayuechaxun',
  	component: () => import('@/views/haomayuechaxun/index'),
  },

    //api相关
    {
    	path: '/zhanghuguanli',
    	name: 'zhanghuguanli',
    	component: () => import('@/views/zhanghuguanli/index'),
      redirect:"/zhanghuguanli/wodetuandui",
      children:[
        {
        	path: '/zhanghuguanli/wodetuandui',
        	name: 'wodetuandui',
        	component: () => import('@/views/zhanghuguanli/wodetuandui')
        },
        {
        	path: '/zhanghuguanli/gangweiguanli',
        	name: 'gangweiguanli',
        	component: () => import('@/views/zhanghuguanli/gangweiguanli')
        },
        {
        	path: '/zhanghuguanli/gongnengdingyi',
        	name: 'gongnengdingyi',
        	component: () => import('@/views/zhanghuguanli/gongnengdingyi')
        },
        {
        	path: '/zhanghuguanli/api',
        	name: 'zhanghuguanliapi',
        	component: () => import('@/views/zhanghuguanli/api')
        },
		{
        	path: '/zhanghuguanli/quanxianguanli',
        	name: 'quanxianguanli',
        	component: () => import('@/views/zhanghuguanli/quanxianguanli')
        },
      ]
    },

    //api相关老
    {
    	path: '/team/api',
    	name: 'teamapi',
    	component:  () => import('@/components/power/api')
    },
    {
    	path: '/team/func',
    	name: 'func',
    	component:  () => import('@/components/power/function')
    },
    {
    	path: '/team/post',
    	name: 'post',
    	component:  () => import('@/components/power/post')
    },
    {
    	path: '/team',
    	name: 'team',
    	component:  () => import('@/components/power/team')
    },

    //消息通知老
    {
    	path: '/message',
    	name: 'message',
    	component: () => import('@/components/message/message')
    },
    {
    	path: '/message/messageerror',
    	name: 'messageerror',
    	component: () => import('@/components/message/messageerror')
    },
    {
    	path: '/message/messagedanger',
    	name: 'messagedanger',
    	component: () => import('@/components/message/messagedanger')
    },






		//微小店
		{
			path: '/minishop',
			name: 'minishop',
			component: () => import('@/components/shop/minishop')
		},
		//微小店
		{
			path: '/wai/wai',
			name: 'wai',
			component: () => import('@/components/wai/wai')
		},
		//蜻蜓fm
		{
			path: '/upload/qingtingfm',
			name: 'qingtingfm',
			component: () => import('@/components/upload/qingtingfm')
		},

		//知识库
		{
			path: '/shangpinzhishi',
			name: 'shangpinzhishi',
			component: () => import('@/components/zhishiku/shangpinzhishi')
		},
		{
			path: '/kefuzhishi',
			name: 'kefuzhishi',
			component: () => import('@/components/zhishiku/kefuzhishi')
		},
		{
			path: '/shangpinlist',
			name: 'shangpinlist',
			component: () => import('@/components/zhishiku/shangpinlist')
		},
		{
			path: '/kefulist',
			name: 'kefulist',
			component: () => import('@/components/zhishiku/kefulist')
		},
    {
    	path: '/kefulist/zhishifenlei',
    	name: 'zhishifenlei',
    	component: () => import('@/components/zhishiku/zhishifenlei')
    },


		//帮助中心
		{
			path: '/help',
			name: 'help',
			component: () => import('@/components/help/help'),
			children: [{
					path: '/help/howtoExamine',
					component:  () => import('@/components/help/howtoExamine'),
				},
				{
					path: '/help/howtoImport',
					component:  () => import('@/components/help/howtoImport'),
				},
				{
					path: '/help/howtoPost',
					component:  () => import('@/components/help/howtoPost'),
				},
				{
					path: '/help/howtoDo',
					component:  () => import('@/components/help/howtoDo'),
				},
				{
					path: '/help/howtoStatistics',
					component:  () => import('@/components/help/howtoStatistics'),
				},
				{
					path: '/help/howtoAdministration',
					component:  () => import('@/components/help/howtoAdministration'),
				},
				{
					path: '/help/howtoExplain',
					component:  () => import('@/components/help/howtoExplain'),
				},
				{
					path: '/help/howtoHandle',
					component:  () => import('@/components/help/howtoHandle'),
				},
				{
					path: '/help/howtoDistribut',
					component:  () => import('@/components/help/howtoDistribut'),
				},
				{
					path: '/help/howtoOptimization',
					component:  () => import('@/components/help/howtoOptimization'),
				},
				{
					path: '/help/howtoDifferent',
					component:  () => import('@/components/help/howtoDifferent'),
				},
				{
					path: '/help/howtoaddSupplier',
					component:  () => import('@/components/help/howtoaddSupplier'),
				},
				{
					path: '/help/howtodoSee',
					component:  () => import('@/components/help/howtodoSee'),
				},
				{
					path: '/help/howtoRelease',
					component:  () => import('@/components/help/howtoRelease'),
				},
				{
					path: '/help/howtoGet',
					component:  () => import('@/components/help/howtoGet'),
				},
				{
					path: '/help/howtoAlt',
					component:  () => import('@/components/help/howtoAlt'),
				},
				{
					path: '/help/howtoaddDistributor',
					component:  () => import('@/components/help/howtoaddDistributor'),
				},
				{
					path: '/help/howtoSend',
					component:  () => import('@/components/help/howtoSend'),
				},

			]
		},
    {
    	path: '/tianmaoyong',
    	component:  () => import('@/components/tianmaoyong'),
    },

		//财务
		{
			path: '/finance/finance',
			name: 'finance',
			component: () => import('@/components/finance/finance'),
		},
		{
			path: '/finance/financenumber',
			name: 'financenumber',
			component: () => import('@/components/finance/financenumber'),
		},
    //返利
    {
    	path: '/finance/ke',
    	name: 'ke',
    	component: () => import('@/components/finance/fanli/ke'),
    },
    {
    	path: '/finance/ke/daorubiao',
    	name: 'kedaorubiao',
    	component: () => import('@/components/finance/fanli/daorubiao'),
    },
	{
    	path: '/finance/ke/chuangjiandingdanjilu',
    	name: 'chuangjiandingdanjilu',
    	component: () => import('@/components/finance/fanli/chuangjiandingdanjilu'),
    },
    {
    	path: '/finance/kedaoru',
    	name: 'kedaoru',
    	component: () => import('@/components/finance/fanli/kedaoru'),
    },
    {
    	path: '/finance/wait',
    	name: 'wait',
    	component: () => import('@/components/finance/fanli/wait'),
    },
    {
    	path: '/finance/jilu',
    	name: 'jilu',
    	component: () => import('@/components/finance/fanli/jilu'),
    },
    {
    	path: '/finance/wait/daochu',
    	name: 'waitdaochu',
    	component: () => import('@/components/finance/fanli/waitdaochu'),
    },


		{
			path: '/finance/financemoney',
			name: 'financemoney',
			component: () => import('@/components/finance/financemoney'),
		},
		{
			path: '/finance/myDistributork',
			name: 'myDistributork',
			component: () => import('@/components/finance/myDistributork'),
		},

		{
			path: '/finance/fiancelist',
			name: 'fiancelist',
			component: () => import('@/components/finance/fiancelist'),
		},
		{
			path: '/finance/fiancelist2',
			name: 'fiancelist2',
			component: () => import('@/components/finance/fiancelist2'),
		},
		{
			path: '/finance/fiancedown',
			name: 'fiancedown',
			component: () => import('@/components/finance/fiancedown'),
		},
		{
			path: '/finance/onlinecommission',
			name: 'onlinecommission',
			component: () => import('@/components/finance/onlinecommission'),
		},
		{
			path: '/finance/onlinecommission/nolinecommission',
			name: 'nolinecommission',
			component: () => import('@/components/finance/nolinecommission'),
		},

		{
			path: '/finance/onlinecommission/record',
			name: 'record',
			component: () => import('@/components/finance/record'),
		},
		{
			path: '/finance/onlinecommission/fazhan',
			name: 'fazhan',
			component: () => import('@/components/finance/fazhan'),
		},
		{
			path: '/finance/fazhandetail',
			name: 'fazhandetail',
			component: () => import('@/components/finance/fazhandetail'),
		},

		{
			path: '/finance/zhichu/querenzhichu',
			name: 'querenzhichu',
			component: () => import('@/components/finance/querenzhichu'),
		},
		{
			path: '/finance/zhichu/zhichunew',
			name: 'zhichunew',
			component: () => import('@/components/finance/zhichunew'),
		},


		{
			path: '/finance/onlinecommission/tkshouru',
			name: 'tkshouru',
			component: () => import('@/components/finance/tkshouru'),
		},
		{
			path: '/finance/onlinecommission/tkchakan',
			name: 'tkchakan',
			component: () => import('@/components/finance/tkchakan'),
		},

		{
			path: '/finance/zhichu/tkzhichu',
			name: 'tkzhichu',
			component: () => import('@/components/finance/tkzhichu'),
		},
    {
    	path: '/finance/zhichu',
    	name: 'zhichu',
    	component: () => import('@/components/finance/zhichu'),
    },

		{
			path: '/finance/zhichu/dakuan',
			name: 'dakuan',
			component: () => import('@/components/finance/dakuan'),
		},
		//短信相关

    {
    	path: '/shenheyong',
    	name: 'shenheyong',
    	component: () => import('@/components/duanxin/shenheyong'),
    },
		{
			path: '/duanxin',
			name: 'duanxinrenwuguanli',
			component: () => import('@/components/duanxin/renwuguanli'),
		},
    {
    	path: '/duanxin/duanxintongji',
    	name: 'duanxintongji',
    	component: () => import('@/components/duanxin/duanxintongji'),
    },
		{
			path: '/duanxin/fasongjilu',
			name: 'fasongjilu',
			component: () => import('@/components/duanxin/fasongjilu'),
		},
		{
			path: '/duanxin/addrenwu',
			name: 'addrenwu',
			component: () => import('@/components/duanxin/addrenwu'),
		},
		{
			path: '/duanxin/addrenwu2',
			name: 'addrenwu2',
			component: () => import('@/components/duanxin/addrenwu2'),
		},
		{
			path: '/duanxin/duanxinshenhe',
			name: 'duanxinshenhe',
			component: () => import('@/components/duanxin/duanxinshenhe'),
		},
		{
			path: '/duanxin/duanxinmobanshenhe',
			name: 'duanxinmobanshenhe',
			component: () => import('@/components/duanxin/duanxinmobanshenhe'),
		},
		{
			path: '/duanxin/duanxinmoban',
			name: 'duanxinmoban',
			component: () => import('@/components/duanxin/duanxinmoban'),
		},
		{
			path: '/duanxin/duanxinchongzhi',
			name: 'duanxinchongzhi',
			component: () => import('@/components/duanxin/duanxinchongzhi'),
		},
    {
    	path: '/duanxin/duanxinqianmingguanli',
    	name: 'duanxinqianmingguanli',
    	component: () => import('@/components/duanxin/duanxinqianmingguanli'),
    },

		//推广站点
		{
			path: '/productionDelivery/marketsite/siteadmin',
			name: 'siteadmin',
			component: () => import('@/components/marketsite/siteadmin'),
		},
		{
			path: '/productionDelivery/marketsite/siteproduct',
			name: 'siteproduct',
			component: () => import('@/components/marketsite/siteproduct'),
		},
		{
			path: '/marketsite/siteerweima',
			name: 'siteerweima',
			component: () => import('@/components/marketsite/siteerweima'),
		},



		{
			path: '/personalCenter',
			name: 'personalCenter',
			component:  () => import('@/components/personal/personalCenter'),
		},
		{
			path: '/myshop',
			name: 'myshop',
			component:  () => import('@/components/personal/myshop'),
		},
		{
			path: '/myshop/recharge',
			name: 'recharge',
			component:  () => import('@/components/personal/recharge'),
		},
		{
			path: '/myshop/consumption',
			name: 'consumption',
			component:  () => import('@/components/personal/consumption'),
		},
		{
			path: '/consumption_export',
			name: 'consumption_export',
			component:  () => import('@/components/personal/consumption_export'),
		},
		//外呼模块

		{
			path: '/callsystem/taskControl',
			name: 'taskControl',
			component:  () => import('@/components/callsystem/taskControl'),
		},
		{
			path: '/callsystem/taskCenter',
			name: 'taskCenter',
			component:  () => import('@/components/callsystem/taskCenter'),
		},
		{
			path: '/callsystem/callOut',
			name: 'callOut',
			component:  () => import('@/components/callsystem/callOut'),
		},
		{
			path: '/callsystem/callOrder',
			name: 'callOrder',
			component:  () => import('@/components/callsystem/callOrder'),
		},
		{
			path: '/callsystem/taskDetail',
			name: 'taskDetail',
			component:  () => import('@/components/callsystem/taskDetail'),
		},
		{
			path: '/callsystem/personReport',
			name: 'personReport',
			component:  () => import('@/components/callsystem/personReport'),
		},
		{
			path: '/callsystem/taskReport',
			name: 'taskReport',
			component:  () => import('@/components/callsystem/taskReport'),
		},
		{
			path: '/callsystem/callLogs',
			name: 'callLogs',
			component:  () => import('@/components/callsystem/callLogs'),
		},
		{
			path: '/callsystem/orderCallLogs',
			name: 'orderCallLogs',
			component:  () => import('@/components/callsystem/orderCallLogs'),
		},
		{
			path: '/callsystem/personDetail',
			name: 'personDetail',
			component:  () => import('@/components/callsystem/personDetail'),
		},
		{
			path: '/callsystem/three',
			name: 'three',
			component:  () => import('@/components/callsystem/three'),
		},

		//外呼登录
		{
			path: '/callsystem/wlogin',
			name: 'wlogin',
			component:  () => import('@/components/callsystem/wlogin'),
		},

		//iccid 帮忙做的
		{
			path: '/iccidimport',
			name: 'iccidimport',
			component:  () => import('@/components/iccid/iccidimport'),
		},
		{
			path: '/iccidselect',
			name: 'iccidselect',
			component:  () => import('@/components/iccid/iccidselect'),
		},

		//上传小工具
		{
			path: '/upload',
			name: 'upload',
			component:  () => import('@/components/upload/upload'),
		},

		//下单小工具
		{
			path: '/order_tools',
			name: 'order_tools',
			component:  () => import('@/components/ordertools/order_tools'),
		},

		//注册登录
		{
			path: '/register',
			name: 'register',
			component:  () => import('@/components/register')
		},

		//忘记密码
		{
			path: '/noremember',
			name: 'noremember',
			component: () => import('@/components/noremember'),
			meta: {
				title: '忘记密码'
			}
		},

		{
			path: '/shangxiajia',
			name: 'shangxiajia',
			component: () => import('@/views/shangxiajia'),
			meta: {
				title: '上下架操作记录'
			}
		},

		{
			path: '/productionDelivery/shangxiajiajilu',
			name: 'shangxiajiajilu',
			component: () => import('@/components/productionDelivery/shangxiajiajilu'),
			meta: {
				title: '上下架操作记录'
			}
		},
		{
			path: '/productionDelivery/yongjinjilu',
			name: 'yongjinjilu',
			component: () => import('@/components/productionDelivery/yongjinjilu'),
			meta: {
				title: '佣金操作记录'
			}
		},
    {
    	path: '/productionDelivery/yongjinjiluchengjie',
    	name: 'yongjinjiluchengjie',
    	component: () => import('@/components/productionDelivery/yongjinjiluchengjie'),
    	meta: {
    		title: '承接佣金操作记录'
    	}
    },
		{
			path: '/productionDelivery/fanlijilu',
			name: 'fanlijilu',
			component: () => import('@/components/productionDelivery/fanlijilu'),
			meta: {
				title: '返利操作记录'
			}
		},

    {
    	path: '/productionDelivery/order_export_shangpin',
    	name: 'order_export_shangpin',
    	component: () => import('@/components/productionManagement/order_export_shangpin')
    },

		{
			path: '/login',
			name: 'login',
			component: () => import('@/components/login'),
		},

		//规则
		{
			path: '/rule',
			name: 'rule',
			component: () => import('@/components/rule'),
		},

		//店铺设置
		{
			path: '/setup',
			name: 'setup',
			component: () => import('@/components/setup/setup'),
			children: [
				{
					path: '/setup/flag',
					component: () => import('@/components/setup/flag'),
				},
        {
        	path: '/setup/miyao',
        	component: () => import('@/components/setup/miyao'),
        },

        {
        	path: '/setup/zhubodingdanchaxunlianjie',
        	component: () => import('@/components/setup/zhubodingdanchaxunlianjie'),
        },
        {
        	path: '/setup/wuliuguijichaxun',
        	component: () => import('@/components/setup/wuliuguijichaxun'),
        },
        {
        	path: '/setup/chongfudingdan',
        	component: () => import('@/components/setup/chongfudingdan'),
        },
        {
        	path: '/setup/dingdanchaxun',
        	component: () => import('@/components/setup/dingdanchaxun'),
        },

				{
					path: '/setup/heimingdan',
					component: () => import('@/components/setup/heimingdan/index'),
          redirect: '/setup/heimingdan/shoujihao',
          children:[
            {
            	path: '/setup/heimingdan/shoujihao',
            	component: () => import('@/components/setup/heimingdan/shoujihao'),
            },
            {
            	path: '/setup/heimingdan/shenfenzheng',
            	component: () => import('@/components/setup/heimingdan/shenfenzheng'),
            },
            {
            	path: '/setup/heimingdan/dizhi',
            	component: () => import('@/components/setup/heimingdan/dizhi'),
            }
          ]
				},

        {
        	path: '/setup/heimingdan2',
        	component: () => import('@/components/setup/heimingdan2/index'),
          redirect: '/setup/heimingdan2/shoujihao',
          children:[
            {
            	path: '/setup/heimingdan2/shoujihao',
            	component: () => import('@/components/setup/heimingdan2/shoujihao'),
            },
            {
            	path: '/setup/heimingdan2/shenfenzheng',
            	component: () => import('@/components/setup/heimingdan2/shenfenzheng'),
            },
            {
            	path: '/setup/heimingdan2/dizhi',
            	component: () => import('@/components/setup/heimingdan2/dizhi'),
            }
          ]
        },

        {
        	path: '/setup/guize',
        	component: () => import('@/components/setup/guize/index'),
          redirect: '/setup/guize/dizhiku',
          children:[
            {
            	path: '/setup/guize/dizhiku',
            	component: () => import('@/components/setup/guize/dizhiku'),
            }
          ]
        },

        {
        	path: '/setup/dingdanlaiyuan',
        	component: () => import('@/components/setup/dingdanlaiyuan'),
          redirect: '/setup/dingdanlaiyuan/dingdanlaiyuan',
          children:[
            {
            	path: '/setup/dingdanlaiyuan/dingdanlaiyuan',
            	component: () => import('@/components/setup/dingdanlaiyuan/dingdanlaiyuan'),
            },
            {
            	path: '/setup/dingdanlaiyuan/dingdanlaiyuan/peizhi',
            	component: () => import('@/components/setup/dingdanlaiyuan/peizhi'),
            },
            {
            	path: '/setup/dingdanlaiyuan/xiaoshouqudao',
            	component: () => import('@/components/setup/dingdanlaiyuan/xiaoshouqudao'),
            },
            {
            	path: '/setup/dingdanlaiyuan/chongmingming',
            	component: () => import('@/components/setup/dingdanlaiyuan/chongmingming'),
            },


          ]
        }
			]
		},


		//号池号码管理
		{
			path: '/numberManagement',
			name: 'numberManagement',
			component: () => import('@/components/numberManagement/numberManagenment'),
			children: [{
					path: '/productionBasismanag/numberManagement/number',
					component: () => import('@/components/numberManagement/number')
				},
				{
					path: '/productionBasismanag/numberManagement/numberBase',
					component: () => import('@/components/numberManagement/numberBase')
				}
			]
		},




		//辅助工具
		{
			path: '/fuzhugongju',
			name: 'fuzhugongju',
			component: () => import('@/components/message/fuzhugongju')
		},
    {
    	path: '/fuzhugongju2',
    	name: 'fuzhugongju2',
    	component: () => import('@/components/message/fuzhugongju2')
    },
    {
    	path: '/fuzhugongju2douyin',
    	name: 'fuzhugongju2douyin',
    	component: () => import('@/components/message/fuzhugongju2douyin')
    },


		{
			path: '/myDistributor',
			name: 'myDistributor',
			component:  () => import('@/components/myDistributor/myDistributor')
		},
		{
			path: '/myDistributor/addfenzu',
			name: 'addfenzu',
			component:  () => import('@/components/myDistributor/addfenzu')
		},
		{
			path: '/myDistributor/managelist',
			name: 'managelist',
			component:  () => import('@/components/myDistributor/managelist')
		},
		{
			path: '/myDistributor/addtag',
			name: 'addtag',
			component:  () => import('@/components/myDistributor/addtag')
		},

		{
			path: '/myDistributor/myDistributorshop',
			name: 'myDistributorshop',
			component:  () => import('@/components/myDistributor/myDistributorshop')
		},

		{
			path: '/editMoney',
			name: 'editMoney',
			component:  () => import('@/components/myDistributor/editMoney')
		},






		//查看我的分销商
		{
			path: '/productionDelivery/watchMyDistributor',
			name: 'watchMyDistributor',
			component: () => import('@/components/productionDelivery/watchMyDistributor')
		},
    //查看卡单队列
    {
    	path: '/productionDelivery/kadanduilie',
    	name: 'kadanduilie',
    	component: () => import('@/components/productionDelivery/kadanduilie')
    },


		//抖音商品
		{
			path: '/productionDelivery2/douyin',
			name: 'douyin',
			component: () => import('@/components/productionDelivery/douyin')
		},
		{
			path: '/productionDelivery2/douyinaddlist',
			name: 'douyinaddlist',
			component: () => import('@/components/productionDelivery/douyinaddlist')
		},
		{
			path: '/productionDelivery2/douyinfabu',
			name: 'douyinfabu',
			component: () => import('@/components/productionDelivery/douyinfabu')
		},
		{
			path: '/productionDelivery2/douyinfabuxiaochengxulinshi',
			name: 'douyinfabuxiaochengxulinshi',
			component: () => import('@/components/productionDelivery/douyinfabuxiaochengxulinshi')
		},
    {
    	path: '/productionDelivery2/douyin2',
    	name: 'douyin2',
    	component: () => import('@/components/productionDelivery/douyin2')
    },
    {
    	path: '/productionDelivery2/douyin3',
    	name: 'douyin3',
    	component: () => import('@/components/productionDelivery/douyin3')
    },
    {
    	path: '/productionDelivery2/douyin4',
    	name: 'douyin4',
    	component: () => import('@/components/productionDelivery/douyin4')
    },
    {
    	path: '/productionDelivery2/douyin5',
    	name: 'douyin5',
    	component: () => import('@/components/productionDelivery/douyin5')
    },


		{
			path: '/productionBasismanag/productionBasis',
			name: 'productionBasis',
			component: () => import('@/components/productionDelivery/productionBasis')
		},
		{
			path: '/shandongdianxin',
			name: 'shandongdianxin',
			component: () => import('@/components/shandongdianxin/index')
		},
		{
			path: '/zhouyijian',
			name: 'zhouyijian',
			component: () => import('@/components/shandongdianxin/zhouyijian')
		},



		{
			path: '/addProduct',
			name: 'addProduct',
			component: () => import('@/components/productionDelivery/addProduct')
		},

    {
    	path: '/productionBasismanag/qudaoguanli',
    	name: 'qudaoguanli',
    	component: () => import('@/components/productionDelivery/qudaoguanli')
    },

    {
    	path: '/productionBasismanag/xianzhi',
    	name: 'xianzhi',
    	component: () => import('@/components/productionDelivery/xianzhi')
    },
    {
    	path: '/productionBasismanag/xianzhiduilie',
    	name: 'xianzhiduilie',
    	component: () => import('@/components/productionDelivery/xianzhiduilie')
    },
    {
    	path: '/productionBasismanag/xianzhiqudao',
    	name: 'xianzhiqudao',
    	component: () => import('@/components/productionDelivery/xianzhiqudao')
    },
    {
    	path: '/productionBasismanag/xianzhiqudaoduilie',
    	name: 'xianzhiqudaoduilie',
    	component: () => import('@/components/productionDelivery/xianzhiqudaoduilie')
    },
    {
    	path: '/productionBasismanag/lanjieduilie',
    	name: 'lanjieduilie',
    	component: () => import('@/components/productionDelivery/lanjieduilie')
    },

		{
			path: '/productionBasismanag/addBasis',
			name: 'addBasis',
			component: () => import('@/components/productionDelivery/addBasis')
		},
    {
    	path: '/productionBasismanag/chanpinall',
    	name: 'chanpinall',
    	component: () => import('@/components/productionDelivery/chanpinall')
    },


		{
			path: '/productionDelivery/addShop',
			name: 'addShop',
			component: () => import('@/components/productionDelivery/addShop')
		},

    {
    	path: '/productionDelivery/addshop_new',
    	name: 'addshop_new',
    	component: () => import('@/components/productionDelivery/addshop_new')
    },



    {
    	path: '/productionDelivery/shengchengtu',
    	name: 'shengchengtu',
    	component: () => import('@/components/productionDelivery/shengchengtu')
    },
    {
    	path: '/productionDelivery/shengchengxiangqingtu',
    	name: 'shengchengxiangqingtu',
    	component: () => import('@/components/productionDelivery/shengchengxiangqingtu')
    },

    {
    	path: '/productionDelivery/addShop2',
    	name: 'addShop2',
    	component: () => import('@/components/productionDelivery/addShop2')
    },

    {
    	path: '/productionDelivery/zhuandan',
    	name: 'zhuandan',
    	component: () => import('@/components/productionDelivery/zhuandan'),
      meta: {
      	title: '转单'
      }
    },


		{
			path: '/zhibodaka',
			name: 'zhibodaka',
			component: () => import('@/components/zhibotongji/zhibodaka')
		},
		{
			path: '/zhibodaka2',
			name: 'zhibodaka2',
			component: () => import('@/components/zhibotongji/zhibodaka2')
		},
		{
			path: '/addliucheng',
			name: 'addliucheng',
			component: () => import('@/components/zhibotongji/addliucheng')
		},
		{
			path: '/zhibotongji',
			name: 'zhibotongji',
			component: () => import('@/components/zhibotongji/zhibotongji')
		},
		{
			path: '/zhibotongji/editdaka',
			name: 'editdaka',
			component: () => import('@/components/zhibotongji/editdaka')
		},

		{
			path: '/zhibotongji/zhuboguanli',
			name: 'zhuboguanli',
			component: () => import('@/components/zhibotongji/zhuboguanli')
		},
		{
			path: '/zbdetail',
			name: 'zbdetail',
			component: () => import('@/components/zhibotongji/zbdetail')
		},

    //新直播
    {
    	path: '/zhibodaka9',
    	name: 'zhibodakaxin',
    	component: () => import('@/components/zhibotongji2/zhibodaka')
    },
    // {
    // 	path: '/zhibodaka9',
    // 	name: 'zhibodaka9',
    // 	component: () => import('@/components/zhibotongji2/zhibodaka2')
    // },
    {
    	path: '/addliucheng9',
    	name: 'addliucheng9',
    	component: () => import('@/components/zhibotongji2/addliucheng')
    },
    {
    	path: '/zhibotongji9',
    	name: 'zhibotongji9',
    	component: () => import('@/components/zhibotongji2/zhibotongji')
    },
    {
    	path: '/zhibotongji9/editdaka',
    	name: 'editdaka9',
    	component: () => import('@/components/zhibotongji2/editdaka')
    },
    {
    	path: '/zhibotongji9/zhuboguanli',
    	name: 'zhuboguanli9',
    	component: () => import('@/components/zhibotongji2/zhuboguanli')
    },
    {
    	path: '/zhibotongji9/zhanduiguanli',
    	name: 'zhanduiguanli',
    	component: () => import('@/components/zhibotongji2/zhanduiguanli')
    },
    {
    	path: '/zbdetail9',
    	name: 'zbdetail9',
    	component: () => import('@/components/zhibotongji2/zbdetail')
    },
    //结束

		// {
		// 	path: '/productionBasismanag',
		// 	name: 'productionBasismanag',
		// 	component: () => import('@/components/productionDelivery/productionBasismanag')
		// },
		// {
		// 	path: '/productionBasismanag/productionBasismanagSoldout',
		// 	name: 'productionBasismanagSoldout',
		// 	component: () => import('@/components/productionDelivery/productionBasismanagSoldout')
		// },
		// {
		// 	path: '/productionBasismanag/productionBasismanagDj',
		// 	name: 'productionBasismanagDj',
		// 	component: () => import('@/components/productionDelivery/productionBasismanagDj')
		// },
    // {
    // 	path: '/productionBasismanag/productionBasismanagAI',
    // 	name: 'productionBasismanagAI',
    // 	component: () => import('@/components/productionDelivery/productionBasismanagAI')
    // },
    // {
    // 	path: '/productionBasismanag/productionBasismanagAItidan',
    // 	name: 'productionBasismanagAItidan',
    // 	component: () => import('@/components/productionDelivery/productionBasismanagAItidan')
    // },
		// {
		// 	path: '/productionBasismanag/productionBasismanagCheck',
		// 	name: 'productionBasismanagCheck',
		// 	component: () => import('@/components/productionDelivery/productionBasismanagCheck')
		// },
		// {
		// 	path: '/productionBasismanag/apicheckorder',
		// 	name: 'apicheckorder',
		// 	component: () => import('@/components/productionDelivery/apicheckorder')
		// },
    // {
    // 	path: '/productionBasismanag/qudaodingdan',
    // 	name: 'qudaodingdan',
    // 	component: () => import('@/components/productionDelivery/qudaodingdan')
    // },


		{
			path: '/h5template',
			name: 'h5template',
			component: () => import('@/components/productionDelivery/h5template')
		},
		{
			path: '/productionBasismanag/fixproductionBasis',
			name: 'fixproductionBasis',
			component: () => import('@/components/productionDelivery/fixproductionBasis')
		},
		{
			path: '/fixProductbasis',
			name: 'fixProductbasis',
			component: () => import('@/components/productionDelivery/fixProductbasis')
		},

		{
			path: '/addPros',
			name: 'addPros',
			component: () => import('@/components/productionDelivery/addPros')
		},
    {
    	path: '/addPros2',
    	name: 'addPros2',
    	component: () => import('@/components/productionDelivery/addPros2')
    },
		{
			path: '/productionDelivery/fixPros',
			name: 'fixPros',
			component: () => import('@/components/productionDelivery/fixPros')
		},
    {
    	path: '/productionDelivery/shangpinall',
    	name: 'shangpinall',
    	component: () => import('@/components/productionDelivery/shangpinall')
    },
	{
		path: '/productionDelivery/kefuxiugai',
		name: 'kefuxiugai',
		component: () => import('@/components/productionDelivery/kefuxiugai/kefuxiugai')
	},

		{
			path: '/fixProduct',
			name: 'fixProduct',
			component: () => import('@/components/productionDelivery/fixProduct')
		},
		{
			path: '/productionDelivery/fixproductmoney',
			name: 'fixproductmoney',
			component: () => import('@/components/productionDelivery/fixproductmoney')
		},
		{
			path: '/productionDelivery/fixproductmoney2',
			name: 'fixproductmoney2',
			component: () => import('@/components/productionDelivery/fixproductmoney2')
		},
		{
			path: '/productSee',
			name: 'productSee',
			component: () => import('@/components/productionDelivery/productSee')
		},
		{
			path: '/ordergo',
			name: 'ordergo',
			component: () => import('@/components/productionDelivery/ordergo')
		},
		{
			path: '/productHistory',
			name: 'productHistory',
			component: () => import('@/components/productionDelivery/productHistory')
		},
		{
			path: '/productionDelivery/shopdetail',
			name: 'shopdetail',
			component: () => import('@/components/productionDelivery/shopdetail')
		},
		{
			path: '/productionBasismanag/detailproduct',
			name: 'detailproduct',
			component: () => import('@/components/productionDelivery/detailproduct')
		},

		{
			path: '/productExamine',
			name: 'productExamine',
			component: () => import('@/components/productionDelivery/productExamine')
		},




		//趋势
		{
			path: '/qushi',
			name: 'qushi',
			component: () => import('@/components/profit/qushi')
		},
		{
			path: '/productionDelivery/yugu',
			name: 'yugu',
			component: () => import('@/components/profit/yugu')
		},
		{
			path: '/shangpinshouzhi',
			name: 'shangpinshouzhi',
			component: () => import('@/components/profit/shangpinshouzhi')
		},
		{
			path: '/dianpuqushi',
			name: 'dianpuqushi',
			component: () => import('@/components/profit/dianpuqushi')
		},
		{
			path: '/qudaoqushi',
			name: 'qudaoqushi',
			component: () => import('@/components/profit/qudaoqushi')
		},

		{
			path: '/tuiguang',
			name: 'tuiguang',
			component: () => import('@/components/profit/tuiguang')
		},

		{
			path: '/qudaoshouzhi',
			name: 'qudaoshouzhi',
			component: () => import('@/components/profit/qudaoshouzhi')
		},

		//api相关

		{
			path: '/addapi',
			name: 'addapi',
			component: () => import('@/components/api/addapi')
		},
		{
			path: '/apidetail',
			name: 'apidetail',
			component: () => import('@/components/api/apidetail')
		},
		{
			path: '/apilist',
			name: 'apilist',
			component: () => import('@/components/api/apilist')
		},
		//新外呼
		{
			path: '/callsystem/newcalls/guanlizhongxin',
			name: 'guanlizhongxinrenwuguanli',
			component:  () => import('@/components/callsystem/newcalls/renwuguanli'),
		},
		{
			path: '/callsystem/newcalls/guanlizhongxin/renwuexcel',
			name: 'renwuexcel',
			component:  () => import('@/components/callsystem/newcalls/renwuexcel'),
		},
		{
			path: '/callsystem/newcalls/guanlizhongxin/yingxiaoexcel',
			name: 'yingxiaoexcel',
			component:  () => import('@/components/callsystem/newcalls/yingxiaoexcel'),
		},
		{
			path: '/callsystem/newcalls/guanlizhongxin/peoexcel',
			name: 'peoexcel',
			component:  () => import('@/components/callsystem/newcalls/peoexcel'),
		},
		{
			path: '/callsystem/newcalls/guanlizhongxin/peoexceldet',
			name: 'peoexceldet',
			component:  () => import('@/components/callsystem/newcalls/peoexceldet'),
		},
		{
			path: '/callsystem/newcalls/guanlizhongxin/addpeo',
			name: 'addpeo',
			component:  () => import('@/components/callsystem/newcalls/addpeo'),
		},
		{
			path: '/callsystem/newcalls/guanlizhongxin/addphone',
			name: 'addphone',
			component:  () => import('@/components/callsystem/newcalls/addphone'),
		},
		{
			path: '/callsystem/newcalls/guanlizhongxin/detail',
			name: 'detail',
			component:  () => import('@/components/callsystem/newcalls/detail'),
		},
		{
			path: '/callsystem/newcalls/fengkong',
			name: 'fengkongpeizhi',
			component:  () => import('@/components/callsystem/newcalls/fengkongpeizhi'),
		},
		{
			path: '/callsystem/newcalls/fengkong/fengkongmingdan',
			name: 'fengkongmingdan',
			component:  () => import('@/components/callsystem/newcalls/fengkongmingdan'),
		},
		{
			path: '/callsystem/newcalls/waihuzhongxin',
			name: 'waihurenwu',
			component:  () => import('@/components/callsystem/newcalls/waihurenwu'),
		},
		{
			path: '/callsystem/newcalls/waihuzhongxin/bodajilu',
			name: 'bodajilu',
			component:  () => import('@/components/callsystem/newcalls/bodajilu'),
		},
		{
			path: '/callsystem/newcalls/waihuzhongxin/bodajilu2',
			name: 'bodajilu2',
			component:  () => import('@/components/callsystem/newcalls/bodajilu2'),
		},
		{
			path: '/callsystem/newcalls/waihuzhongxin/waihuorder',
			name: 'waihuorder',
			component:  () => import('@/components/callsystem/newcalls/waihuorder'),
		},
		{
			path: '/callsystem/newcalls/waihuzhongxin/calldig',
			name: 'calldig',
			component:  () => import('@/components/callsystem/newcalls/calldig'),
		},

	]
})



// WEBPACK FOOTER //
// ./src/router/index.js